module.exports = __webpack_public_path__ + "img/send_email.3464bc91.png";